import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS, INLINES, MARKS } from '@contentful/rich-text-types';
import Img from "gatsby-image";
import React, { useEffect, useState } from 'react';
import Icon from '../../../shared/components/atoms/Icon/Icon';
import ArticleService from '../../../shared/services/articles';
import SessionService from '../../../shared/services/session';
import { formatDate } from '../../../shared/state/utils/utilities-date';
import './sectionArticle.scss';
import LeafletCard from '../../../shared/components/molecules/leaflet-card/leaflet-card';
import Button from '../../../shared/components/atoms/Button/Button';
import useSessionState from '../../../shared/hooks/useSessionState';

const capitalize = text => {
  return text.charAt(0).toUpperCase() + text.slice(1);
}

const SectionArticle = (props) => {

  const { descripcionArticuloCompleta, createdAt, etiquetas, imagenArticuloCompleta, categorias } = props.article;
  let slug = categorias[0].slug;
  let tag = etiquetas[0].nombreDeEtiqueta.toLowerCase();
  let options = {
    renderMark: {
      [MARKS.BOLD]: text => <span className={`f-${slug}`}>{text}</span>,
      [MARKS.CODE]: link => <span className="f-iframe-content" dangerouslySetInnerHTML={{ __html: link }}></span>
    },
    renderNode: {
      [BLOCKS.HEADING_1]: (node, next) => <h1 className={`f-h1 f-${slug}`}>{next}</h1>,
      [BLOCKS.HEADING_6]: (node, next) => <div className="f-article-pattern"><p className="f-p" >{next}</p><Button text="INSCRÍBETE" type="button" classname="f-button f-button--clear-transparent" onClickAction={() => { !isLoggedUser && document.getElementById('leafletCard').scrollIntoView({ behavior: 'smooth'});}} /></div>,
      [BLOCKS.EMBEDDED_ASSET]: (node, next) => <img src={node.data.target.fields.file['es-CO'].url} alt={node.data.target.fields.description['es-CO']} />,
      [INLINES.HYPERLINK]: (node, next) => <a href={node.data.uri} target="_blank">{next}</a>
    }
  }
  // console.log(JSON.stringify(descripcionArticuloCompleta.json))
  const [localLikes, setlocalLikes] = useState([])
  const [isFakeLiked, setisFakeLiked] = useState(false)
  const [isFakeUnLiked, setisFakeUnLiked] = useState(false)
  const [likeValue, setlikeValue] = useState(null)
  const { isLoggedUser } = useSessionState();
  const formatNumber = (num) => {
    if (num > 999999) {
      return parseInt(num / 1000000, 10).toString() + 'M'
    } else if (num > 999) {
      return parseInt(num / 1000, 10).toString() + 'K'
    } else {
      return num
    }
  }

  const isLiked = (idProduct) => {
    let i
    for (i = 0; i < localLikes.length; i++) {
      if (localLikes[i] === idProduct) {
        return true;
      }
    }

    return false;
  }

  useEffect(() => {
    handleLoadLikes();
    setlocalLikes(localStorage.getItem('LOCAL_LIKES_ARTICLES') !== null ? JSON.parse(localStorage.getItem('LOCAL_LIKES_ARTICLES')) : [])
  }, [])

  const handleLoadLikes = () => {
    if (!(localStorage.getItem('tokenData') || sessionStorage.getItem('tokenData'))) {
      ArticleService.getAnomLikes().then(res => {
        setlikeValue(res.data.filter(item => { if (item.idCMS === props.article.id) { return item.like } })[0].like)

      }).catch(e => console.log(e));
    } else {
      localStorage.removeItem('LOCAL_LIKES_ARTICLES');

      const config = {
        headers: {
          Authorization: SessionService.getIdTokenData(),
        },
      }

      ArticleService.getAuthLikes(config).then(res => {
        for (let index = 0; index < res.data.length; index++) {
          if (res.data[index].userLike) {
            if (localStorage.getItem('LOCAL_LIKES_ARTICLES') !== null) {
              const copyLocalLikes = JSON.parse(localStorage.getItem("LOCAL_LIKES_ARTICLES"))
              localStorage.setItem('LOCAL_LIKES_ARTICLES', JSON.stringify(copyLocalLikes.concat(res.data[index].idCMS)))
              setlocalLikes(copyLocalLikes.concat(res.data[index].idCMS))
            } else {
              localStorage.setItem('LOCAL_LIKES_ARTICLES', JSON.stringify([res.data[index].idCMS]))
              setlocalLikes([res.data[index].idCMS])
            }
          }
        }
        setlikeValue(res.data.filter(item => {
          if (item.idCMS === props.article.id) {
            return item.like
          }
        })[0].like);
      }).catch(e => console.log(e));
    }
  }

  const handleUnLike = () => {
    const payload = {
      type: "ARTICULO",
      idCMS: props.article.id,
    }

    if (!(localStorage.getItem('tokenData') || sessionStorage.getItem('tokenData'))) {
      ArticleService.setAnomUnLikes(payload).then(res => {
        if (res.status === 200) {
          const copyLocalLikes = JSON.parse(localStorage.getItem("LOCAL_LIKES_ARTICLES"))
          localStorage.setItem('LOCAL_LIKES_ARTICLES', JSON.stringify(copyLocalLikes.filter(item => item !== props.article.id)))
          setlocalLikes(copyLocalLikes.filter(item => item !== props.article.id))
          isFakeLiked ? setisFakeLiked(false) : setisFakeUnLiked(true)
        } else {
          console.log(res)
        }
      }).catch(e => console.log(e))
    } else {
      const config = {
        headers: {
          Authorization: SessionService.getIdTokenData(),
        },
      }

      ArticleService.setAuthUnLikes(payload, config).then(res => {
        if (res.status === 200) {
          const copyLocalLikes = JSON.parse(localStorage.getItem("LOCAL_LIKES_ARTICLES"))
          localStorage.setItem('LOCAL_LIKES_ARTICLES', JSON.stringify(copyLocalLikes.filter(item => item !== props.article.id)))
          setlocalLikes(copyLocalLikes.filter(item => item !== props.article.id))
          isFakeLiked ? setisFakeLiked(false) : setisFakeUnLiked(true)
        } else {
          console.log(res)
        }
      }).catch(e => console.log(e));
    }
  }

  const handleLike = () => {
    const payload = {
      type: "ARTICULO",
      idCMS: props.article.id,
    }

    if (!(localStorage.getItem('tokenData') || sessionStorage.getItem('tokenData'))) {
      ArticleService.setAnomLikes(payload).then(res => {

        if (res.status === 200) {

          if (localStorage.getItem('LOCAL_LIKES_ARTICLES') !== null) {
            const copyLocalLikes = JSON.parse(localStorage.getItem("LOCAL_LIKES_ARTICLES"))
            localStorage.setItem('LOCAL_LIKES_ARTICLES', JSON.stringify(copyLocalLikes.concat(props.article.id)))
            setlocalLikes(copyLocalLikes.concat(props.article.id))
            isFakeUnLiked ? setisFakeUnLiked(false) : setisFakeLiked(true)
          } else {
            localStorage.setItem('LOCAL_LIKES_ARTICLES', JSON.stringify([props.article.id]))
            setlocalLikes([props.article.id])
            isFakeUnLiked ? setisFakeUnLiked(false) : setisFakeLiked(true)
          }
        } else {
          console.log(res)
        }
      }).catch(e => console.log(e))
    } else {
      const config = {
        headers: {
          Authorization: SessionService.getIdTokenData(),
        },
      }
      ArticleService.setAuthLikes(payload, config).then(res => {
        if (res.status === 200) {
          if (localStorage.getItem('LOCAL_LIKES_ARTICLES') !== null) {
            const copyLocalLikes = JSON.parse(localStorage.getItem("LOCAL_LIKES_ARTICLES"))
            localStorage.setItem('LOCAL_LIKES_ARTICLES', JSON.stringify(copyLocalLikes.concat(props.article.id)))
            setlocalLikes(copyLocalLikes.concat(props.article.id))
            isFakeUnLiked ? setisFakeUnLiked(false) : setisFakeLiked(true)
          } else {
            localStorage.setItem('LOCAL_LIKES_ARTICLES', JSON.stringify([props.article.id]))
            setlocalLikes([props.article.id])
            isFakeUnLiked ? setisFakeUnLiked(false) : setisFakeLiked(true)
          }
        } else {
          console.log(res)
        }
      }).catch(e => console.log(e));
    }
  }

  let createDate = new Date(createdAt);

  return (
    <>
      <div className={isLoggedUser ? "f-article-wrapper f-article-wrapper--fullwidth" : "f-article-wrapper"}>
        <div className={isLoggedUser ? "f-article f-article--fullwidth" : "f-article"}>
          <p className="f-article-date">{formatDate(createDate)}<Icon icon={`icon-circle f-${slug}`} size="0-6" tagtype="i" /><span className={`f-${slug}`}>{capitalize(tag)}</span></p>
          {imagenArticuloCompleta &&
            <Img fluid={imagenArticuloCompleta[!props.ismobile ? 0 : 1].fluid} alt={imagenArticuloCompleta[!props.ismobile ? 0 : 1].description} />}
          <div className="f-contentsection">
            {descripcionArticuloCompleta && documentToReactComponents(descripcionArticuloCompleta.json, options)}
          </div>
          <div className="f-likes-container">
            {isLiked(props.article.id) ?
              <div className="f-icon-heart" onClick={() => handleUnLike()}></div>
              :
              <div className="f-icon-heart-gray" onClick={() => handleLike()}></div>
            }
            <label className="f-count-likes">{formatNumber(isFakeLiked ? likeValue + 1 : isFakeUnLiked ? likeValue - 1 : likeValue)}</label>
          </div>
        </div>
        {isLoggedUser ? null :
          <div id="leafletCard" className="f-leaflet-container">
            <div className="f-leaflet-content">
              <LeafletCard isMobile={true} leafletContent={props.leafletContent} />
            </div>
          </div>
        }
      </div>
      {props.products}
    </>
  )
}

SectionArticle.propTypes = {

}

export default SectionArticle;